import { getOrderDetail } from "@/apis/crypto";
import { CryptoOrederInfo } from "@/types/Api/Crypto";
import { Toast } from "antd-mobile";
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import QRCode from 'qrcode';
import { FormInstance } from "antd-mobile/es/components/form";
import { amountFormat } from "@/utils/tool";


const updateQRcode = (str: string) => {
  str && QRCode.toDataURL(str).then((url: string) => {
    const $QRcode = document.querySelector(".QRcode");
    $QRcode && $QRcode.setAttribute("src", url);
  });
}
export const useLogic = ()=> {
  const {orderNo} = useParams();
  const [orderInfo, setOrderInfo]=useState<CryptoOrederInfo>({
    orderId: 0,
    orderNo: "",
    userId: 0,
    paymentType: "",
    passageType: "",
    amount: "",
    copeAmount: "",
    actualAmount: "",
    receivingAddress: "",
    paymentAddress: "",
    appeal: 0,
    operatorAdminId: 0,
    status: "",
    createDate: "",
    createTime: "",
    finishDate: "",
    finishTime: "",
    updateTime: "",
    txid: "",
    remark: "",
    toTxid: "",
    feeRate: 0,
  })

  const formRef = useRef<FormInstance>();
  const formRef1 = useRef<FormInstance>();
  const onFormRef = useCallback((form: FormInstance) =>{
    formRef.current = form;
  },[])

  const onFormRef1 = useCallback((form: FormInstance) =>{
    formRef1.current = form;
  },[])
  useEffect(() => {
    const timer = setInterval(() => {
      if(formRef.current && formRef1.current){
        clearInterval(timer);
        fetchOrderDetail();
      }
    }, 200)
    
  }, [])
  useEffect(() => {
    updateQRcode(orderInfo.receivingAddress);
  }, [orderInfo.receivingAddress])
  
  const fetchOrderDetail = async () => {
    const { ok, data, msg } = await getOrderDetail({ orderNo:orderNo as string});
      if (ok) {
        formRef1.current?.setFieldsValue({
          receivingAddress: data.order.receivingAddress ,
          amount: parseFloat(data.order.amount || 0).toFixed(2) ,
          copeAmount: parseFloat(data.order.copeAmount|| 0).toFixed(2) ,
          actualAmount: parseFloat(data.order.actualAmount|| 0).toFixed(2) ,
          depositAmount: parseFloat(data.order.depositAmount|| 0).toFixed(2) ,
          feeRate: data.order.feeRate,
          remark: data.order.remark,
        })

        formRef.current?.setFieldsValue({
          orderNo: data.order.orderNo,
        })
        setOrderInfo(data.order);
        
      } else {
        Toast.show(msg);
      }
  }


  return {
    onFormRef, 
    onFormRef1,
    orderInfo
  }
}